//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

export default {
  name: 'ContentCross',

  props: {
    contents: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      CDN: process.env.CDN,
    };
  },

  computed: {
    ...mapState(['isMobile']),
  },

  methods: {
    isEven(contentId) {
      return contentId % 2 === 0;
    },
    imgSrc(contentId) {
      return `${this.CDN}/tutorial/tutorial_${contentId}${
        this.isEven(contentId) ? '.png' : '.jpg'
      }`;
    },
    bgSrc(contentId) {
      return `${this.CDN}/tutorial/tutorial_bg_${contentId}${
        this.isMobile ? '_m' : ''
      }.jpg`;
    },
  },
};
